/**
 * Result of copying one or more advanced filter groups (cross-store or General → Stock Take).
 */
export interface IAdvancedFilterCopyFailure {
  filterId: number;
  filterName: string;
  message: string;
}

export interface IAdvancedFilterCopyResult {
  copiedCount: number;
  failures: IAdvancedFilterCopyFailure[];
  skippedCount: number;
}
